function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Box from '../Box';
const ChecklistItem = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    field,
    form,
    hasError: _hasError,
    label,
    sx,
    values,
    value,
    ...props
  } = _ref;
  const handleChange = () => {
    const currentValues = Array.isArray(values) ? values : [];
    const newValues = currentValues.includes(value) ? currentValues.filter(v => v !== value) : [...currentValues, value];
    return form.setFieldValue(field.name, newValues);
  };
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: "input",
    checked: values.includes(value)
  }, field, props, {
    value: value,
    onChange: handleChange,
    type: "checkbox",
    __css: {
      mr: '6px'
    }
  }));
});
ChecklistItem.propTypes = {};
ChecklistItem.defaultProps = {};
ChecklistItem.displayName = 'ChecklistItem';
export default ChecklistItem;